import React from 'react';
import { ThumbsUp, ThumbsDown } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/context/AuthContext';
import { useTranslation } from 'react-i18next';

interface ReadingLikeProps {
    readingId: string;
    className?: string;
    evaluation: boolean | null;
    isLoading: boolean;
    onEvaluationClick: (isHelpful: boolean) => Promise<void>;
}



const ReadingLike: React.FC<ReadingLikeProps> = ({
    readingId,
    className = "",
    evaluation,
    isLoading,
    onEvaluationClick
}) => {
    const { user } = useAuth();
    const { t } = useTranslation();



    if (!user) {
        return null; // Don't show evaluation buttons if user is not authenticated
    }

    return (
        <>
            <div className={`flex flex-col items-center gap-2 ${className}`}>
                <span className="text-sm text-gray-600">
                    {t('reading.wasThisHelpful')}
                </span>
                <div className="flex items-center gap-4">
                    <Button
                        variant="ghost"
                        onClick={() => onEvaluationClick(true)}
                        disabled={isLoading}
                        className={`p-3 transition-all duration-200 [&_svg]:!w-8 [&_svg]:!h-8 ${evaluation === true
                            ? 'text-green-600 hover:text-green-700'
                            : 'text-gray-400 hover:text-green-600'
                            }`}
                    >
                        <ThumbsUp
                            className={`transition-all duration-200 ${evaluation === true ? 'fill-current' : ''
                                }`}
                        />
                    </Button>

                    <Button
                        variant="ghost"
                        onClick={() => onEvaluationClick(false)}
                        disabled={isLoading}
                        className={`p-3 transition-all duration-200 [&_svg]:!w-8 [&_svg]:!h-8 ${evaluation === false
                            ? 'text-red-600 hover:text-red-700'
                            : 'text-gray-400 hover:text-red-600'
                            }`}
                    >
                        <ThumbsDown
                            className={`transition-all duration-200 ${evaluation === false ? 'fill-current' : ''
                                }`}
                        />
                    </Button>
                </div>
            </div>
        </>
    );
};

export default ReadingLike; 